import { Template } from '@nlpjs/evaluator';

const template = new Template();

const hasTemplateSyntax = s => typeof s === 'string' && s.includes('{{');

/**
 * Aligns with rely-back chatflowCompileMessageText (NLP.js {{ expression }} templates).
 */
export const compileChatFlowStoredMessage = (message, templateContext) => {
  if (!message || typeof message !== 'object') {
    return message;
  }
  const out = { ...message };
  if (hasTemplateSyntax(out.text)) {
    out.text = template.compile(out.text, templateContext);
  }
  if (hasTemplateSyntax(out.title)) {
    out.title = template.compile(out.title, templateContext);
  }
  if (Array.isArray(out.blocks) && out.blocks.length > 0) {
    out.blocks = template.compile(JSON.parse(JSON.stringify(out.blocks)), templateContext);
  }
  return out;
};
